// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1MVD6","paramInput":"JobSimulator_paramInput__zPU4m","input":"JobSimulator_input__3L2XC"};